<template>
  <div>
    <!-- <div class="declaration">
                <span>诚信宣言</span>
                <a class="download" @click="download" href="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/en_declaration.docx" download="en_declaration.docx">
                  <i class="el-icon-download"></i>下载
                </a>
              </div> -->

    <div class="bill-info">
      <div class="title">{{ $t('PCUserInfo.index.647kboa09440') }}</div>

      <div v-if="nationCode == 'GB'" class="item">
        <div class="item-left">Sort Code</div>
        <div class="item-right">
          <input
            v-model="formattedBIC"
            type="text"
            inputmode="numeric"
            pattern="[0-9-]*"
            maxlength="8"
            :placeholder="$t('PCUserInfo.index.647kboa09u40')"
            @input="formatBIC"
            @blur="validateBIC"
          />
        </div>
      </div>
      <div class="item">
        <div class="item-left">
          {{ nationCode == 'GB' ? 'Account Number' : 'IBAN' }}
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="white-space: pre-line">
              {{ $t('PCUserInfo.index.ibanTip') }}
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <div class="item-right">
          <input
            v-if="nationCode == 'GB'"
            ref="ibanInput"
            v-model="form.iban"
            type="text"
            :placeholder="$t('PCUserInfo.index.647kboa09u40')"
            inputmode="numeric"
            maxlength="8"
            @input="validateAccountNumber"
            @keypress="allowOnlyNumbers"
          />

          <input
            v-else
            v-model="formattedIBAN"
            type="text"
            :placeholder="$t('PCUserInfo.index.647kboa09u40')"
            maxlength="42"
            @input="formatIBAN"
          />
          <div v-if="errorMessage" class="error-tip">{{ errorMessage }}</div>
        </div>
      </div>
    </div>

    <div class="declaration">
      <span> {{ $t('PCUserInfo.index.declaration') }}</span>
      <span class="download" @click="download">
        <i class="el-icon-download"></i>
        {{ $t('PCUserInfo.index.download') }}
      </span>
    </div>
  </div>
</template>

<script>
import { lang } from '@/locales';
export default {
  name: 'billInfo',
  props: {
    info: Object,
    nationCode: String
  },
  data() {
    return {
      form: {
        bic: '',
        iban: ''
      },
      errorMessage: '',
      lastCursorPos: 0, // 记录光标位置
      isDownload: false,
      lang
    };
  },
  computed: {
    downLoadHref() {
      return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_oppoeu_declaration.pdf`;
    },
    // 格式化后的 IBAN（带空格）
    formattedIBAN: {
      get() {
        return this.addSpaces(this.form.iban);
      },
      set(value) {
        // 去除空格并存储原始值
        this.form.iban = value.replace(/\s+/g, '');
      }
    },
    // formattedBIC: {
    //   get() {
    //     return this.addLine(this.form.bic);
    //   },
    //   set(value) {
    //     // 去除空格并存储原始值
    //     this.form.bic = value.replace(/\s+/g, '');
    //   }
    // }
    formattedBIC: {
      get() {
        if (!this.form.bic) {
          return '';
        }
        const digits = this.form.bic.replace(/\D/g, '');
        return digits.replace(/(\d{2})(\d{0,2})(\d{0,2})/, (_, a, b, c) => [a, b, c].filter(Boolean).join('-'));
      },
      set(value) {
        this.form.bic = value.replace(/\D/g, '');
      }
    }
  },
  watch: {
    /**
     * 监听表单数据填写
     */
    form: {
      deep: true,
      immediate: true,
      handler: function (val) {
        // let flag = Boolean(val && val.iban && !this.errorMessage);
        // let data = {
        //   flag,
        //   form: val
        // };

        // 基础判断：val 存在 + 没有错误信息
        const basicCheck = Boolean(val && val.iban && !this.errorMessage);

        // 银行信息判断：
        // - 如果是英国 (GB)，检查 bic
        // - 如果不是英国，检查 iban
        const bankInfoCheck =
          this.nationCode === 'GB'
            ? Boolean(val.bic) // 英国：检查 BIC
            : true;

        // 最终 flag：基础检查 + 银行信息检查
        const flag = basicCheck && bankInfoCheck;

        console.log('flag', flag)

        // 提交的数据
        const data = {
          flag,
          form: val
        };
        this.$emit('completeBill', data, this.isDownload);
      }
    }
  },
  mounted() {
    this.isDownload = this.info.isDownload;
    const { bic, iban } = this.info;
    this.form = {
      bic,
      iban
    };
  },
  methods: {
    // Allow only numeric input
    allowOnlyNumbers(e) {
      const charCode = e.which ? e.which : e.keyCode;
      // Allow: 0-9
      if (charCode < 48 || charCode > 57) {
        e.preventDefault();
      }
    },

    // Validate and format the account number
    validateAccountNumber() {
      // Remove all non-digit characters
      this.form.iban = this.form.iban.replace(/\D/g, '');
      // Limit to 8 digits
      if (this.form.iban.length > 8) {
        this.form.iban = this.form.iban.substring(0, 8);
      }
    },
    download() {
      console.log(this.downLoadHref);
      fetch(this.downLoadHref)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'declaration.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // 清理
        });

      const flag = Boolean(this.form && this.form.iban);
      const data = {
        flag,
        form: this.form
      };
      this.isDownload = true;
      this.$emit('completeBill', data, this.isDownload);
    },
    // 格式化输入（过滤非字母数字 + 转大写 + 自动加空格）
    formatIBAN(event) {
      // 保存光标位置
      this.lastCursorPos = event.target.selectionStart;

      // 1. 过滤非字母数字字符
      let value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');

      // 2. 转大写
      value = value.toUpperCase();

      // 3. 校验前两位必须为字母
      if (value.length > 0 && !/^[A-Z]{2}/.test(value)) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
        // value = value.slice(2) // 移除前两位非法字符
      } else {
        this.errorMessage = '';
      }

      // 4. 限制长度并更新
      this.form.iban = value.substring(0, 34);

      if (!this.form.iban) {
        this.errorMessage = this.$t('PCUserInfo.index.647kboa09u40');
      } else if (this.form.iban.length < 6) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      } else if (!/^[A-Z]{2}[A-Z0-9]+$/.test(this.form.iban)) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      }

      // 5. 格式化显示
      this.$nextTick(() => {
        // 恢复光标位置（考虑新增的空格）
        const input = this.$refs.ibanInput;
        const addedSpaces = Math.floor(this.lastCursorPos / 4);
        const newCursorPos = Math.min(this.lastCursorPos + addedSpaces, this.formattedIBAN.length);
        input.selectionStart = input.selectionEnd = newCursorPos;
      });
    },

    validateIBAN() {
      if (!this.form.iban) {
        this.errorMessage = this.$t('PCUserInfo.index.647kboa09u40');
      } else if (this.form.iban.length < 6) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      } else if (!/^[A-Z]{2}[A-Z0-9]+$/.test(this.form.iban)) {
        this.errorMessage = this.$t('PCUserInfo.index.idError');
      }
    },

    // 每 4 位加空格
    addSpaces(value) {
      return value.replace(/(.{4})/g, '$1 ').trim();
    },

    formatBIC(event) {
      const input = event.target;
      const cursorPos = input.selectionStart;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 6) {
        value = value.slice(0, 6);
      }
      this.form.bic = value;

      let formatted = '';
      for (let i = 0; i < value.length; i++) {
        if (i === 2 || i === 4) {
          formatted += '-';
        }
        formatted += value[i];
      }

      input.value = formatted;

      this.$nextTick(() => {
        let newCursorPos = cursorPos;
        if (cursorPos === 3 || cursorPos === 6) {
          newCursorPos++;
        }
        if (value.length < 3 && cursorPos > 2) {
          newCursorPos = 2;
        }
        if (value.length < 5 && cursorPos > 5) {
          newCursorPos = 5;
        }
        newCursorPos = Math.min(newCursorPos, formatted.length);
        input.setSelectionRange(newCursorPos, newCursorPos);
      });
    },
    validateBIC() {
      if (this.nationCode === 'GB' && this.form.bic.length !== 6) {
        this.errors.bic = '请输入 6 位数字的 Sort Code（如 20-19-63）';
      } else {
        this.errors.bic = '';
      }
    }
  }
};
</script>

<style scoped lang="less">
.declaration {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  color: #333;
  padding: 30px 24px;
  font-size: 28px;
  .download {
    color: #ff9600;
  }
}
.bill-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f4f5f7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5d5f65;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      input {
        border: none;
        padding: 0;
        font-size: 28px;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #f00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #ff9600;
          font-size: 24px;
          border-radius: 10px;
        }
      }
    }
  }
  .item:last-child {
    border-bottom: none;
  }
}
</style>
